import { FC, ReactElement, ReactNode } from 'react';
import { Stack, SvgIcon, Typography } from '@mui/material';

import { useTranslation } from '@mopla/i18';
import { MplButton } from '@mopla/ui';
import MailFilledIcon from '@mopla/ui/icons/MailFilledIcon.svg';
import { FormTitle } from '@mopla/ui/layouts/WelcomeScreen';

import { pushAuthEvent } from '../../../../app/userTracking/events';
import { environment } from '../../../../environments/environment';
import { SocialLogin } from '../../SocialLogin/SocialLogin';
import { ERegistrationFormSteps } from '../RegistrationForm';

interface ISelectFlowStepProps {
	setActiveRegStep(step: ERegistrationFormSteps): void;
	render: (p: { content: ReactNode; submit: ReactNode }) => ReactElement;
}

export const SelectFlowStep: FC<ISelectFlowStepProps> = ({
	setActiveRegStep,
	render,
}) => {
	const { t } = useTranslation('registration');

	return render({
		content: (
			<Stack className="content">
				<FormTitle testId="registrationForm-email-title">
					{t('label.newAccount')}
				</FormTitle>
				<Stack gap={3}>
					<MplButton
						fullWidth
						color="primaryButtonV2"
						testId="welcomeScreen-continue-with-email-button"
						startIcon={
							<SvgIcon
								fontSize="small"
								component={MailFilledIcon}
								inheritViewBox
							/>
						}
						onClick={() => {
							pushAuthEvent('sign_up_attempt', 'email');
							setActiveRegStep(ERegistrationFormSteps.Email);
						}}
					>
						{t('logIn:button.emailPwdContinue')}
					</MplButton>
					<Typography variant="b2" color="solutions.700" textAlign="center">
						{t('common:text.or')}
					</Typography>
					<SocialLogin
						isRegistration={true}
						socialLoginMethods={[...environment.allowedSocialLoginMethods]}
					/>
				</Stack>
			</Stack>
		),
		submit: null,
	});
};
